<script>
import { mapActions } from 'pinia';
import { useCartStore } from '../stores/cart.js';

export default {
    props: {
        productId: Number
    },
    data() {
        return {
            quantity: 1
        }
    },
    computed: {
        inCart() {
            return this.inCartStore(this.productId);
        },
        cartUrl() {
            if (window.Application?.config?.lang_code === "ru") {
                return "/cart/";
            }

            return "/" + window.Application?.config?.lang_code + "/cart/";
        }

    },
    methods: {
        ...mapActions(useCartStore, {
            inCartStore: "inCart",
            changeCart: "change"
        }),

        plus() {
            if (this.quantity < 99999) {
                this.quantity++;
            }
        },
        minus() {
            if (this.quantity > 1) {
                this.quantity--;
            }
        },
        onInput(e) {
            let value = e.target.value.replace(/\D/g, "");

            if (value === "") {
                this.quantity = 1; 
                e.target.value = "1";
                return;
            }
            
            let num = parseInt(value, 10);
            
            if (num > 99999) {
                num = 99999;
            }
            if (num < 1) {
                num = 1;
            }

            this.quantity = num;
            e.target.value = num; 
        },
        addToCart() {
            this.changeCart(this.productId, this.quantity);
        }
    },
    mounted() {
        const cartStore = useCartStore();
        cartStore.setup();
    }
}
</script>

<template>
    <div class="add__cart_block" :class="{already: inCart}">
        <template v-if="inCart">
            <a class="button" :href="cartUrl">
                <svg-icon name="cart" class="icon" />
                <span class="text">{{ $s("STR_ALREADY_CARD") }}</span>
            </a>
        </template>

        <template v-else>
            <div class="quantity__input">
                <button
                    type="button"
                    class="item__btn input__item_minus"
                    @click="minus"
                >
                    <span data-icon="minus" class="icon"></span>
                </button>

                <div class="amount">
                    <input
                        type="text"
                        class="input__field"
                        :value="quantity"
                        @input="onInput"
                    >
                </div>

                <button
                    type="button"
                    class="item__btn input__item_plus"
                    @click="plus"
                >
                    <span data-icon="plus" class="icon"></span>
                </button>

            </div>

            <button
                class="button to-cart"
                @click="addToCart"
            >
                <svg-icon name="cart" class="icon" />
                <span class="text">{{ $s("STR_TO_CARD") }}</span>
            </button>

        </template>
    </div>
</template>